
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { actions } from '@/store/types';
import { SignupActionType } from '@/types/store/actions';
import {
    contactUsURL,
    privacyPolicyURL,
    termsAndConditionsURL,
    passwordValidationDescription,
} from '@/constants/constants';
import VueRecaptcha from 'vue-recaptcha';
import { reCAPTCHASiteKey } from '@/config';
import { countriesOptions } from '@/constants/countries';
import { getCurrency } from '@/utils/currency';

@Component({
    components: { 'vue-recaptcha': VueRecaptcha },
})
export default class Signup extends Vue {
    @Action(actions.SIGNUP)
    signup!: SignupActionType;

    passwordValidationDescription = passwordValidationDescription;
    contactUsURL = contactUsURL;
    privacyPolicyURL = privacyPolicyURL;
    termsAndConditionsURL = termsAndConditionsURL;
    username = '';
    email = '';
    password = '';
    passwordViewType = 'password';
    checkbox = false;
    reCAPTCHASiteKey = reCAPTCHASiteKey;
    protected captchaVerified = false;
    countriesOptions = countriesOptions;
    country: string | undefined = '';
    protected getCurrency = getCurrency;
    uppercaseValid = true;
    lowercaseValid = true;
    numberValid = true;
    symbolValid = true;
    lengthValid = true;

    async handleSignup(e: Event) {
        e.preventDefault();

        if (!this.country) return Vue.toasted.error('Country is required');
        if (!this.checkbox)
            return Vue.toasted.error('Please agree to Terms of Service and Privacy Policy before continue');
        if (!this.captchaVerified) {
            return Vue.toasted.error(`reCAPTCHA required`);
        }

        this.signup({
            name: this.username,
            email: this.email,
            country: this.country,
            currency: this.getCurrency(this.country ?? ''),
            password: this.password,
        });
    }

    redirectTo(url: string) {
        window.open(url, '_blank');
    }

    onCaptchaVerified(response: any) {
        if (response) this.captchaVerified = true;
    }

    onCaptchaExpired() {
        this.captchaVerified = false;
    }
    validatePassword() {
      const lowercaseRegex = /[a-z]/;
      const uppercaseRegex = /[A-Z]/;
      const numberRegex = /\d/;
      const symbolRegex = /[!#$%&'()*+,-./:;<=>?@[\]^_`{|}~\\/]/;
      this.lowercaseValid = lowercaseRegex.test(this.password);
      this.uppercaseValid = uppercaseRegex.test(this.password);
      this.numberValid = numberRegex.test(this.password);
      this.symbolValid = symbolRegex.test(this.password);
      this.lengthValid = this.password.length >= 8;
    }
}
